/* eslint-disable @typescript-eslint/no-explicit-any */
"use client"

import { datadog } from "@/platform/observability/datadog/facade"

const browserAttribution = (user: Record<string, unknown>) =>
  Object.fromEntries(Object.entries(user).filter(([key]) => key === "nelo_pseudo_id" || key === "is_react_native_webview" || key.startsWith("experiment.")))

export const viewerUser = (viewer: string, current: Record<string, unknown> | undefined): Record<string, unknown> => ({
  ...browserAttribution(current ?? {}),
  ...(viewer === "anonymous" ? {} : { id: viewer }),
})

export function setDatadogUser(userId: string, properties?: Record<string, any>): void {
  if (typeof window === "undefined") return

  const current = datadog.getUser()
  const userData = { ...browserAttribution(current), ...(current.id === userId ? current : {}), id: userId, ...properties }

  datadog.setUser(userData)
}

export function setDatadogSessionUser(userUuid: string | null): void {
  if (typeof window === "undefined") return
  if (userUuid) return setDatadogUser(userUuid, { nelo_user_uuid: userUuid })

  const attribution = browserAttribution(datadog.getUser())
  datadog.clearUser()
  if (typeof attribution.nelo_pseudo_id === "string") {
    datadog.setUser({ ...attribution, id: attribution.nelo_pseudo_id })
  } else {
    for (const [key, value] of Object.entries(attribution)) datadog.setUserProperty(key, value)
  }
}

export function setDatadogPseudoId(pseudoId: string): void {
  if (typeof window === "undefined") return
  if (!datadog.getUser().nelo_user_uuid) setDatadogUser(pseudoId)
  setDatadogUserProperty("nelo_pseudo_id", pseudoId)
}

export function setDatadogUserProperty(key: string, value: any): void {
  if (typeof window === "undefined") return

  datadog.setUserProperty(key, value)
}

export function setDatadogGlobalProperty(key: string, value: any): void {
  if (typeof window === "undefined") return

  datadog.setGlobalContextProperty(key, value)
}

export function removeDatadogGlobalProperty(key: string): void {
  if (typeof window === "undefined") return

  datadog.removeGlobalContextProperty(key)
}

export function hasDatadogGlobalProperty(key: string): boolean {
  if (typeof window === "undefined") return false

  return key in datadog.getGlobalContext()
}
